import { render, staticRenderFns } from "./PassWordEdit.vue?vue&type=template&id=16f22622"
import script from "./PassWordEdit.vue?vue&type=script&lang=js"
export * from "./PassWordEdit.vue?vue&type=script&lang=js"
import style0 from "./PassWordEdit.vue?vue&type=style&index=0&id=16f22622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports